export default __webpack_public_path__ + "static/media/HoonJung.6bd997fb.jpg";